import { useState } from 'react';
import { useSelector } from 'react-redux';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { Avatar, AvatarProps, Button, IconName, Stack } from '@optimus-web/core';
import { getImageUrlOrNull, getFullName } from '@mews-commander/utils';
import { useCurrentUser } from '@mews-commander/core';
import { getImageBaseUrl } from '../../../../../app/reducers/configuration';
import { useDeleteProfilePhoto } from './queries/useDeleteProfilePhoto';
import { UploadProfilePhotoDialog } from './UploadProfilePhotoDialog';

const useAvatarProps = (): Pick<AvatarProps, 'src' | 'title'> => {
    const imageBaseUrl = useSelector(getImageBaseUrl);
    const user = useCurrentUser();
    const fullName = getFullName(user);

    return {
        src: getImageUrlOrNull(imageBaseUrl)({ imageId: user.imageId }) || '',
        title: fullName ?? user.email,
    };
};

export const ProfilePhoto = () => {
    const [showModal, setShowModal] = useState(false);
    const avatarProps = useAvatarProps();
    const { mutate: removeProfilePhoto } = useDeleteProfilePhoto();

    return (
        <>
            <Stack spacing="300">
                <Avatar size="extraLarge" {...avatarProps} />
                <Stack spacing="50" itemAlignment="center">
                    <Button type="button" variant="secondary" icon={IconName.Upload} onClick={() => setShowModal(true)}>
                        <LocalizedText textKey={TextKey.UploadPhoto} />
                    </Button>
                    {avatarProps.src ? (
                        <Button type="button" icon={IconName.Delete} onClick={() => removeProfilePhoto()}>
                            <LocalizedText textKey={TextKey.Remove} />
                        </Button>
                    ) : null}
                </Stack>
            </Stack>
            {showModal && <UploadProfilePhotoDialog onClose={() => setShowModal(false)} />}
        </>
    );
};
